import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { Toaster } from "vue-sonner";
import VueLazyload from "vue-lazyload";
import ConfirmDialogPlugin from "components/customUI/confirmDialog/plugin";
import "vue-sonner/style.css";
import loadingSpin from "images/loading-spin.svg?url";
import { properties } from 'utils/globalProperties';
import { initAntiDebug } from 'utils/antiDebug';
import VueLuckyCanvas from '@lucky-canvas/vue'
import { registerSW } from 'virtual:pwa-register'
// Initialize anti-debug protection
initAntiDebug();

import "@/assets/styles/main.css";

// 先创建 pinia，确保在 createApp 之前就准备好
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
// 注册SW，immediate:true 立刻激活service worker
registerSW({
  immediate: true,
  onRegisteredSW(swUrl, r) {
    console.log('Service Worker registered: ', swUrl)
  },
  onRegisterError(error) {
    console.error('SW注册失败', error)
  }
})
// ===== PWA：全局最早捕获 beforeinstallprompt =====
window.__deferredPrompt = null
window.__pwaCanInstall = false

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  window.__deferredPrompt = e
  window.__pwaCanInstall = true
  // 广播给 Vue 组件
  window.dispatchEvent(new CustomEvent('pwa-install-ready'))
})

window.addEventListener('appinstalled', () => {
  window.__deferredPrompt = null
  window.__pwaCanInstall = false
  window.dispatchEvent(new CustomEvent('pwa-app-installed'))
})
// ================================================
const app = createApp(App);
// 立即安装 pinia，确保 App.vue 中的 store 调用能正常工作
app.use(pinia);
// 配置全局路由跟踪
properties(app);

app.component("Toaster", Toaster);
app.use(VueLazyload, {
    loading: loadingSpin,
});
app.use(router);
app.use(i18n);
app.use(VueLuckyCanvas);
app.use(ConfirmDialogPlugin);
app.mount("#root-p");
